<template>
  <div></div>
</template>

<script>
export default {
  name: 'pibot-attachment-uploader'
}
</script>
